import { connect } from 'react-redux'
import {
  Backdrop,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
  TextField,
  Button
} from '@mui/material'
import InputAdornment from '@mui/material/InputAdornment'
import Draft from '@components/Editor/Draft'
import {
  setDealPrice,
  setOfferTerms
} from '@modules/redux/actions'

const SetPriceDialog = (props) => {
  const {
    open,
    closeModal,
    dealPrice,
    offerTerms,
    setDealPrice,
    setOfferTerms,
    setPriceHandler,
    textFieldError
  } = props

  return (
    <Backdrop
      open={open}
      className="modal-filter"
    >
      <Dialog
        open={open}
        onClose={closeModal}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle
          sx={{ textAlign: "center", textTransform: "uppercase" }}
        >
          Set Offer
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Box>
              Setting the Deal Price will change the status of your deal to Offering. If the minimum stake commitment requirement is reached at the end of the Offer Period, your deal will move to a status of Delivering and Claiming. 
            </Box>
            <Box sx={{ mt: 1 }}>
              Once the deal has moved to Delivering, you will be able to download the list of stakes, bonuses, and corresponding addresses.  Once you have completed delivery, and after our admin approves, you can claim the staked amounts.
            </Box>
          </DialogContentText>
          <Box
            className="dialog-form-panel"
            sx={{ mt: 2 }}
          >
            <TextField
              variant="outlined"
              autoFocus
              margin="dense"
              label="Deal Price"
              type="number"
              fullWidth
              size="small"
              value={dealPrice}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
                inputProps: { min: 0 }
              }}
              helperText={
                textFieldError?.price ? 'Incorrect entry' : ''
              }
              error={textFieldError?.price ? true : false}
              onChange={(e) => {
                setDealPrice(e.target.value);
              }}
            />
            <Draft
              value={offerTerms}
              onChange={setOfferTerms}
              placeholder="Offer Terms"
            />
            <Button
              variant="outlined"
              fullWidth
              className="btn-info btn-lg"
              sx={{ mt: 2 }}
              onClick={setPriceHandler}
            >
              SET OFFER
            </Button>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            className="btn-lg"
            fullWidth
            onClick={closeModal}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Backdrop>
  )
}

const mapStateToProps = ({ deal }) => ({
  dealPrice: deal.price,
  offerTerms: deal.offerTerms,
});

const mapToDispatchProps = (dispatch) => ({
  setDealPrice: (price) => dispatch(setDealPrice(price)),
  setOfferTerms: (terms) => dispatch(setOfferTerms(terms))
});

export default connect(mapStateToProps, mapToDispatchProps)(SetPriceDialog);